function initClock() {
  document.addEventListener("DOMContentLoaded", function () {
    const storeTimezone = "Europe/Berlin";
    const storeTimeOffset = parseInt("0") || 0;

    function updateClock() {
      const now = new Date();
      now.setMinutes(now.getMinutes() + storeTimeOffset);

      let timeOptions, dateOptions;

      try {
        timeOptions = {
          timeZone: storeTimezone,
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        };

        dateOptions = {
          timeZone: storeTimezone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        };
      } catch (e) {
        console.warn("Invalid timezone, falling back to local time", e);

        timeOptions = {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false
        };

        dateOptions = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        };
      }

      const timeFormatter = new Intl.DateTimeFormat("de-DE", timeOptions);
      const dateFormatter = new Intl.DateTimeFormat("de-DE", dateOptions);

      const formattedTime = timeFormatter.format(now) + " Uhr";
      const formattedDate = dateFormatter.format(now);

      document.querySelectorAll(".date").forEach((el) => {
        el.textContent = formattedDate;
      });

      document.querySelectorAll(".time").forEach((el) => {
        el.textContent = formattedTime;
      });
    }

    updateClock();
    setInterval(updateClock, 60000);
  });
}

initClock();

if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", function () {
    initClock();
  });
}